import React, { useContext, useState, useEffect, useRef } from 'react';
import { AppContext } from '../App';
import { getInlineLoader, resolveOrientation } from '../Helpers';
import logo_wide from '../assets/logo_wide.png';
import chess_pieces from '../assets/chess_pieces.png';
import cards_row from '../assets/cards_row.png';

export default function MainLoader(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "landscape";
  const [ ready, setReady ] = useState(false);

  const intervalRef = useRef(null);
  const timeoutRef1 = useRef(null);
  const timeoutRef2 = useRef(null);

  const init = () => {
    setReady(true);
    setLaunchImgAnimator();
    
    return () => {
      if(intervalRef.current) {
        clearInterval(intervalRef.current)
      }

      if(timeoutRef1.current) {
        clearTimeout(timeoutRef1.current);
      }

      if(timeoutRef2.current) {
        clearTimeout(timeoutRef2.current);
      }
    }
  }

  function setLaunchImgAnimator() {
    let launcImg = document.getElementById('_launchImg');
    let animator = () => {
      launcImg.src = cards_row;

      timeoutRef1.current = setTimeout(() => {
        launcImg.src = chess_pieces;
      }, 3000);
    }
    
    animator();

    intervalRef.current = setInterval(() => {
      animator();
    }, 6000);
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);


  return (
    <div className='FullPane bg-faint-black'>
      <div
        className=''
        style={{
          width: "100%",
          height: "100%",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >

        <div className='row'>

          <div 
            className='col-12 text-center bg-faint-black'
            style={{
              padding: "20px"
            }}
          >
            <img 
              src={logo_wide}
              style={{
                width: "50%",
                height: "auto",
              }}
            />
          </div>

          <div 
            className='col-12 text-center bg-blackish'
            style={{
              padding: "70px"
            }}
          >
            <h6
              className='font-light text-goldish'
              style={{
                fontSize: "25px",
                letterSpacing: "1px"
              }}
            >
              Play Board Games in Various Local Styles With Friends Online.
            </h6>
          </div>

          <div 
            className='col-12 text-center'
            style={{
              padding: "20px",
              height: "70vw",
              overflow: "hidden",
            }}
          >
            <img 
              src={chess_pieces}
              style={{
                width: "auto",
                height: "100%",
              }}
              id='_launchImg'
            />
          </div>

          <div 
            className='col-12 text-center bg-faint-black'
            style={{
              padding: "10px"
            }}
          >
            <button
              className='btn bg-goldish btn-rounded mSupportLoading'
              style={{
                paddingLeft: "30px",
                paddingRight: "30px",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              {getInlineLoader()}
            </button>
          </div>

        </div>

      </div>
    </div>
  )
}